import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { MonedasConstant } from 'constants/index'

import * as TiposCambioService from 'services/tiposCambio.service'

// TODO > Consistencias constantes
const TipoCambioFormGroup = ({
  iFechaPagoValue,
  iMonedaPagoValue,
  vMoneda,
  iError,
  iTouched,
  fIsSubmitting,
  setFieldValue
}) => {
  const consultarTipoCambio = React.useCallback(
    ({ moneda, tipoTasa }) => {
      TiposCambioService.getxFechaxMonedaxTipoCambio(iFechaPagoValue, moneda, tipoTasa).then(
        ({ data }) => {
          setFieldValue('tipoCambio', data.tipoCambio || 0)
        }
      )
    },
    [iFechaPagoValue, setFieldValue]
  )

  React.useEffect(() => {
    if (iFechaPagoValue !== '') {
      if (vMoneda === MonedasConstant.SOLES && iMonedaPagoValue === MonedasConstant.DOLARES) {
        consultarTipoCambio({ moneda: 'DOLARES', tipoTasa: 'VENT' })
      } else if (
        vMoneda === MonedasConstant.DOLARES &&
        iMonedaPagoValue === MonedasConstant.SOLES
      ) {
        consultarTipoCambio({ moneda: 'DOLARES', tipoTasa: 'VENT' })
      } else {
        setFieldValue('tipoCambio', 1)
      }
    }
  }, [vMoneda, iFechaPagoValue, iMonedaPagoValue, setFieldValue, consultarTipoCambio])

  return (
    <Form.Group>
      <Form.Label text='T/C' htmlFor='input-tipoCambio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='tipoCambio'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='input-tipoCambio'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoCambioFormGroup)
